/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * RAQT Admin API
 * API documentation for RAQT admin applications. Restricted access.
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminOrganizationToursResponseDto,
  ConnectResponseDto,
  ConnectStripeDto,
  CreateLeaderboardDto,
  GetClassStatsParams,
  GetMatchStatsParams,
  GetMessageStatsParams,
  GetPlayerStatsParams,
  GetTicketStatsParams,
  GetTournamentStatsParams,
  LeaderboardDeleteResponseDto,
  LeaderboardResponseDto,
  OrganizationDetailsResponseDto,
  OrganizationStatsResponseDto,
  OverviewStatsResponseDto,
  SendMissingMatchesResponseDto,
  SplitTeamDto,
  SplitTeamResponseDto,
  StatEntryResponseDto,
  TicketStatsResponseDto,
  TourStatsResponseDto,
  UpdateLeaderboardDto
} from './schemas';

import { customInstance } from '../../apis/orval-mutator';
import type { ErrorType } from '../../apis/orval-mutator';




/**
 * @summary Create a leaderboard
 */
export const create = (
    createLeaderboardDto: CreateLeaderboardDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<LeaderboardResponseDto>(
      {url: `/admin/leaderboard`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createLeaderboardDto, signal
    },
      );
    }
  


export const getCreateMutationOptions = <TError = ErrorType<void | void | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof create>>, TError,{data: CreateLeaderboardDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof create>>, TError,{data: CreateLeaderboardDto}, TContext> => {

const mutationKey = ['create'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof create>>, {data: CreateLeaderboardDto}> = (props) => {
          const {data} = props ?? {};

          return  create(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateMutationResult = NonNullable<Awaited<ReturnType<typeof create>>>
    export type CreateMutationBody = CreateLeaderboardDto
    export type CreateMutationError = ErrorType<void | void | void>

    /**
 * @summary Create a leaderboard
 */
export const useCreate = <TError = ErrorType<void | void | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof create>>, TError,{data: CreateLeaderboardDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof create>>,
        TError,
        {data: CreateLeaderboardDto},
        TContext
      > => {

      const mutationOptions = getCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update a leaderboard
 */
export const update = (
    id: string,
    updateLeaderboardDto: UpdateLeaderboardDto,
 ) => {
      
      
      return customInstance<LeaderboardResponseDto>(
      {url: `/admin/leaderboard/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateLeaderboardDto
    },
      );
    }
  


export const getUpdateMutationOptions = <TError = ErrorType<void | void | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof update>>, TError,{id: string;data: UpdateLeaderboardDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof update>>, TError,{id: string;data: UpdateLeaderboardDto}, TContext> => {

const mutationKey = ['update'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof update>>, {id: string;data: UpdateLeaderboardDto}> = (props) => {
          const {id,data} = props ?? {};

          return  update(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateMutationResult = NonNullable<Awaited<ReturnType<typeof update>>>
    export type UpdateMutationBody = UpdateLeaderboardDto
    export type UpdateMutationError = ErrorType<void | void | void>

    /**
 * @summary Update a leaderboard
 */
export const useUpdate = <TError = ErrorType<void | void | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof update>>, TError,{id: string;data: UpdateLeaderboardDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof update>>,
        TError,
        {id: string;data: UpdateLeaderboardDto},
        TContext
      > => {

      const mutationOptions = getUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns tours where the organization is either the owner or has been granted access. Includes minimal tournaments and organizations with access to each tour.
 * @summary Get all tours accessible by an organization
 */
export const getOrganizationTours = (
    orgId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminOrganizationToursResponseDto>(
      {url: `/admin/organization/${orgId}/tours`, method: 'GET', signal
    },
      );
    }
  



export const getGetOrganizationToursQueryKey = (orgId?: number,) => {
    return [
    `/admin/organization/${orgId}/tours`
    ] as const;
    }

    
export const getGetOrganizationToursQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationTours>>, TError = ErrorType<void>>(orgId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationTours>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationToursQueryKey(orgId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationTours>>> = ({ signal }) => getOrganizationTours(orgId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orgId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationTours>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationToursQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationTours>>>
export type GetOrganizationToursQueryError = ErrorType<void>


export function useGetOrganizationTours<TData = Awaited<ReturnType<typeof getOrganizationTours>>, TError = ErrorType<void>>(
 orgId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationTours>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationTours>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationTours>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationTours<TData = Awaited<ReturnType<typeof getOrganizationTours>>, TError = ErrorType<void>>(
 orgId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationTours>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationTours>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationTours>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationTours<TData = Awaited<ReturnType<typeof getOrganizationTours>>, TError = ErrorType<void>>(
 orgId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationTours>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all tours accessible by an organization
 */

export function useGetOrganizationTours<TData = Awaited<ReturnType<typeof getOrganizationTours>>, TError = ErrorType<void>>(
 orgId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationTours>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationToursQueryOptions(orgId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get a leaderboard by id
 */
export const findOne = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<LeaderboardResponseDto>(
      {url: `/admin/leaderboard/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getFindOneQueryKey = (id?: string,) => {
    return [
    `/admin/leaderboard/${id}`
    ] as const;
    }

    
export const getFindOneQueryOptions = <TData = Awaited<ReturnType<typeof findOne>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOne>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof findOne>>> = ({ signal }) => findOne(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindOneQueryResult = NonNullable<Awaited<ReturnType<typeof findOne>>>
export type FindOneQueryError = ErrorType<void>


export function useFindOne<TData = Awaited<ReturnType<typeof findOne>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findOne>>,
          TError,
          Awaited<ReturnType<typeof findOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindOne<TData = Awaited<ReturnType<typeof findOne>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findOne>>,
          TError,
          Awaited<ReturnType<typeof findOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindOne<TData = Awaited<ReturnType<typeof findOne>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOne>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a leaderboard by id
 */

export function useFindOne<TData = Awaited<ReturnType<typeof findOne>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOne>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary List leaderboards for a tour
 */
export const findByTour = (
    tourId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<LeaderboardResponseDto[]>(
      {url: `/admin/leaderboard/tour/${tourId}`, method: 'GET', signal
    },
      );
    }
  



export const getFindByTourQueryKey = (tourId?: string,) => {
    return [
    `/admin/leaderboard/tour/${tourId}`
    ] as const;
    }

    
export const getFindByTourQueryOptions = <TData = Awaited<ReturnType<typeof findByTour>>, TError = ErrorType<unknown>>(tourId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findByTour>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindByTourQueryKey(tourId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof findByTour>>> = ({ signal }) => findByTour(tourId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tourId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findByTour>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindByTourQueryResult = NonNullable<Awaited<ReturnType<typeof findByTour>>>
export type FindByTourQueryError = ErrorType<unknown>


export function useFindByTour<TData = Awaited<ReturnType<typeof findByTour>>, TError = ErrorType<unknown>>(
 tourId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findByTour>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findByTour>>,
          TError,
          Awaited<ReturnType<typeof findByTour>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindByTour<TData = Awaited<ReturnType<typeof findByTour>>, TError = ErrorType<unknown>>(
 tourId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findByTour>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findByTour>>,
          TError,
          Awaited<ReturnType<typeof findByTour>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindByTour<TData = Awaited<ReturnType<typeof findByTour>>, TError = ErrorType<unknown>>(
 tourId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findByTour>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List leaderboards for a tour
 */

export function useFindByTour<TData = Awaited<ReturnType<typeof findByTour>>, TError = ErrorType<unknown>>(
 tourId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findByTour>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindByTourQueryOptions(tourId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete a leaderboard
 */
export const remove = (
    id: string,
 ) => {
      
      
      return customInstance<LeaderboardDeleteResponseDto>(
      {url: `/admin/leaderboard/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getRemoveMutationOptions = <TError = ErrorType<void | void | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remove>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof remove>>, TError,{id: string}, TContext> => {

const mutationKey = ['remove'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof remove>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  remove(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveMutationResult = NonNullable<Awaited<ReturnType<typeof remove>>>
    
    export type RemoveMutationError = ErrorType<void | void | void>

    /**
 * @summary Delete a leaderboard
 */
export const useRemove = <TError = ErrorType<void | void | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remove>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof remove>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getRemoveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Send missing match results to DUPR
 */
export const sendMissingMatches = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<SendMissingMatchesResponseDto>(
      {url: `/admin/dupr/send-missing-matches`, method: 'POST', signal
    },
      );
    }
  


export const getSendMissingMatchesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMissingMatches>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendMissingMatches>>, TError,void, TContext> => {

const mutationKey = ['sendMissingMatches'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendMissingMatches>>, void> = () => {
          

          return  sendMissingMatches()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendMissingMatchesMutationResult = NonNullable<Awaited<ReturnType<typeof sendMissingMatches>>>
    
    export type SendMissingMatchesMutationError = ErrorType<void>

    /**
 * @summary Send missing match results to DUPR
 */
export const useSendMissingMatches = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMissingMatches>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendMissingMatches>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getSendMissingMatchesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Split a team into free agents
 */
export const splitTeam = (
    splitTeamDto: SplitTeamDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SplitTeamResponseDto>(
      {url: `/admin/ticket/split-team`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: splitTeamDto, signal
    },
      );
    }
  


export const getSplitTeamMutationOptions = <TError = ErrorType<void | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof splitTeam>>, TError,{data: SplitTeamDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof splitTeam>>, TError,{data: SplitTeamDto}, TContext> => {

const mutationKey = ['splitTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof splitTeam>>, {data: SplitTeamDto}> = (props) => {
          const {data} = props ?? {};

          return  splitTeam(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SplitTeamMutationResult = NonNullable<Awaited<ReturnType<typeof splitTeam>>>
    export type SplitTeamMutationBody = SplitTeamDto
    export type SplitTeamMutationError = ErrorType<void | void>

    /**
 * @summary Split a team into free agents
 */
export const useSplitTeam = <TError = ErrorType<void | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof splitTeam>>, TError,{data: SplitTeamDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof splitTeam>>,
        TError,
        {data: SplitTeamDto},
        TContext
      > => {

      const mutationOptions = getSplitTeamMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get overview totals for all entities
 */
export const getOverview = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<OverviewStatsResponseDto>(
      {url: `/admin/statistics/overview`, method: 'GET', signal
    },
      );
    }
  



export const getGetOverviewQueryKey = () => {
    return [
    `/admin/statistics/overview`
    ] as const;
    }

    
export const getGetOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getOverview>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOverviewQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOverview>>> = ({ signal }) => getOverview(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getOverview>>>
export type GetOverviewQueryError = ErrorType<unknown>


export function useGetOverview<TData = Awaited<ReturnType<typeof getOverview>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverview>>,
          TError,
          Awaited<ReturnType<typeof getOverview>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverview<TData = Awaited<ReturnType<typeof getOverview>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverview>>,
          TError,
          Awaited<ReturnType<typeof getOverview>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverview<TData = Awaited<ReturnType<typeof getOverview>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverview>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get overview totals for all entities
 */

export function useGetOverview<TData = Awaited<ReturnType<typeof getOverview>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverview>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOverviewQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get player statistics grouped by two dimensions
 */
export const getPlayerStats = (
    params: GetPlayerStatsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<StatEntryResponseDto[]>(
      {url: `/admin/statistics/players`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetPlayerStatsQueryKey = (params?: GetPlayerStatsParams,) => {
    return [
    `/admin/statistics/players`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPlayerStatsQueryOptions = <TData = Awaited<ReturnType<typeof getPlayerStats>>, TError = ErrorType<unknown>>(params: GetPlayerStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlayerStatsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlayerStats>>> = ({ signal }) => getPlayerStats(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlayerStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlayerStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlayerStats>>>
export type GetPlayerStatsQueryError = ErrorType<unknown>


export function useGetPlayerStats<TData = Awaited<ReturnType<typeof getPlayerStats>>, TError = ErrorType<unknown>>(
 params: GetPlayerStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayerStats>>,
          TError,
          Awaited<ReturnType<typeof getPlayerStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlayerStats<TData = Awaited<ReturnType<typeof getPlayerStats>>, TError = ErrorType<unknown>>(
 params: GetPlayerStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayerStats>>,
          TError,
          Awaited<ReturnType<typeof getPlayerStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlayerStats<TData = Awaited<ReturnType<typeof getPlayerStats>>, TError = ErrorType<unknown>>(
 params: GetPlayerStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get player statistics grouped by two dimensions
 */

export function useGetPlayerStats<TData = Awaited<ReturnType<typeof getPlayerStats>>, TError = ErrorType<unknown>>(
 params: GetPlayerStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerStats>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlayerStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get tournament statistics grouped by two dimensions
 */
export const getTournamentStats = (
    params: GetTournamentStatsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<StatEntryResponseDto[]>(
      {url: `/admin/statistics/tournaments`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetTournamentStatsQueryKey = (params?: GetTournamentStatsParams,) => {
    return [
    `/admin/statistics/tournaments`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetTournamentStatsQueryOptions = <TData = Awaited<ReturnType<typeof getTournamentStats>>, TError = ErrorType<unknown>>(params: GetTournamentStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTournamentStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTournamentStatsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTournamentStats>>> = ({ signal }) => getTournamentStats(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTournamentStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTournamentStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getTournamentStats>>>
export type GetTournamentStatsQueryError = ErrorType<unknown>


export function useGetTournamentStats<TData = Awaited<ReturnType<typeof getTournamentStats>>, TError = ErrorType<unknown>>(
 params: GetTournamentStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTournamentStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTournamentStats>>,
          TError,
          Awaited<ReturnType<typeof getTournamentStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTournamentStats<TData = Awaited<ReturnType<typeof getTournamentStats>>, TError = ErrorType<unknown>>(
 params: GetTournamentStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTournamentStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTournamentStats>>,
          TError,
          Awaited<ReturnType<typeof getTournamentStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTournamentStats<TData = Awaited<ReturnType<typeof getTournamentStats>>, TError = ErrorType<unknown>>(
 params: GetTournamentStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTournamentStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get tournament statistics grouped by two dimensions
 */

export function useGetTournamentStats<TData = Awaited<ReturnType<typeof getTournamentStats>>, TError = ErrorType<unknown>>(
 params: GetTournamentStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTournamentStats>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTournamentStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get match statistics grouped by two dimensions
 */
export const getMatchStats = (
    params: GetMatchStatsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<StatEntryResponseDto[]>(
      {url: `/admin/statistics/matches`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetMatchStatsQueryKey = (params?: GetMatchStatsParams,) => {
    return [
    `/admin/statistics/matches`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMatchStatsQueryOptions = <TData = Awaited<ReturnType<typeof getMatchStats>>, TError = ErrorType<unknown>>(params: GetMatchStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMatchStatsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMatchStats>>> = ({ signal }) => getMatchStats(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMatchStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMatchStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getMatchStats>>>
export type GetMatchStatsQueryError = ErrorType<unknown>


export function useGetMatchStats<TData = Awaited<ReturnType<typeof getMatchStats>>, TError = ErrorType<unknown>>(
 params: GetMatchStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMatchStats>>,
          TError,
          Awaited<ReturnType<typeof getMatchStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMatchStats<TData = Awaited<ReturnType<typeof getMatchStats>>, TError = ErrorType<unknown>>(
 params: GetMatchStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMatchStats>>,
          TError,
          Awaited<ReturnType<typeof getMatchStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMatchStats<TData = Awaited<ReturnType<typeof getMatchStats>>, TError = ErrorType<unknown>>(
 params: GetMatchStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get match statistics grouped by two dimensions
 */

export function useGetMatchStats<TData = Awaited<ReturnType<typeof getMatchStats>>, TError = ErrorType<unknown>>(
 params: GetMatchStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchStats>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMatchStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get message statistics grouped by two dimensions
 */
export const getMessageStats = (
    params: GetMessageStatsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<StatEntryResponseDto[]>(
      {url: `/admin/statistics/messages`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetMessageStatsQueryKey = (params?: GetMessageStatsParams,) => {
    return [
    `/admin/statistics/messages`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMessageStatsQueryOptions = <TData = Awaited<ReturnType<typeof getMessageStats>>, TError = ErrorType<unknown>>(params: GetMessageStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessageStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMessageStatsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessageStats>>> = ({ signal }) => getMessageStats(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMessageStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMessageStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getMessageStats>>>
export type GetMessageStatsQueryError = ErrorType<unknown>


export function useGetMessageStats<TData = Awaited<ReturnType<typeof getMessageStats>>, TError = ErrorType<unknown>>(
 params: GetMessageStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessageStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessageStats>>,
          TError,
          Awaited<ReturnType<typeof getMessageStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessageStats<TData = Awaited<ReturnType<typeof getMessageStats>>, TError = ErrorType<unknown>>(
 params: GetMessageStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessageStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessageStats>>,
          TError,
          Awaited<ReturnType<typeof getMessageStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessageStats<TData = Awaited<ReturnType<typeof getMessageStats>>, TError = ErrorType<unknown>>(
 params: GetMessageStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessageStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get message statistics grouped by two dimensions
 */

export function useGetMessageStats<TData = Awaited<ReturnType<typeof getMessageStats>>, TError = ErrorType<unknown>>(
 params: GetMessageStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessageStats>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMessageStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get tour and tour-player statistics
 */
export const getTourStats = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<TourStatsResponseDto>(
      {url: `/admin/statistics/tours`, method: 'GET', signal
    },
      );
    }
  



export const getGetTourStatsQueryKey = () => {
    return [
    `/admin/statistics/tours`
    ] as const;
    }

    
export const getGetTourStatsQueryOptions = <TData = Awaited<ReturnType<typeof getTourStats>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTourStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTourStatsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTourStats>>> = ({ signal }) => getTourStats(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTourStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTourStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getTourStats>>>
export type GetTourStatsQueryError = ErrorType<unknown>


export function useGetTourStats<TData = Awaited<ReturnType<typeof getTourStats>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTourStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTourStats>>,
          TError,
          Awaited<ReturnType<typeof getTourStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTourStats<TData = Awaited<ReturnType<typeof getTourStats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTourStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTourStats>>,
          TError,
          Awaited<ReturnType<typeof getTourStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTourStats<TData = Awaited<ReturnType<typeof getTourStats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTourStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get tour and tour-player statistics
 */

export function useGetTourStats<TData = Awaited<ReturnType<typeof getTourStats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTourStats>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTourStatsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary List all organizations with tournament and player stats
 */
export const getOrganizationDetails = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationDetailsResponseDto[]>(
      {url: `/admin/statistics/organizations/details`, method: 'GET', signal
    },
      );
    }
  



export const getGetOrganizationDetailsQueryKey = () => {
    return [
    `/admin/statistics/organizations/details`
    ] as const;
    }

    
export const getGetOrganizationDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationDetails>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDetails>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationDetailsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationDetails>>> = ({ signal }) => getOrganizationDetails(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationDetails>>>
export type GetOrganizationDetailsQueryError = ErrorType<unknown>


export function useGetOrganizationDetails<TData = Awaited<ReturnType<typeof getOrganizationDetails>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationDetails>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationDetails>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationDetails<TData = Awaited<ReturnType<typeof getOrganizationDetails>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationDetails>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationDetails>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationDetails<TData = Awaited<ReturnType<typeof getOrganizationDetails>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDetails>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all organizations with tournament and player stats
 */

export function useGetOrganizationDetails<TData = Awaited<ReturnType<typeof getOrganizationDetails>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDetails>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationDetailsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get organization statistics by country
 */
export const getOrganizationStats = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationStatsResponseDto[]>(
      {url: `/admin/statistics/organizations`, method: 'GET', signal
    },
      );
    }
  



export const getGetOrganizationStatsQueryKey = () => {
    return [
    `/admin/statistics/organizations`
    ] as const;
    }

    
export const getGetOrganizationStatsQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationStats>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationStatsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationStats>>> = ({ signal }) => getOrganizationStats(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationStats>>>
export type GetOrganizationStatsQueryError = ErrorType<unknown>


export function useGetOrganizationStats<TData = Awaited<ReturnType<typeof getOrganizationStats>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationStats>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationStats<TData = Awaited<ReturnType<typeof getOrganizationStats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationStats>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationStats<TData = Awaited<ReturnType<typeof getOrganizationStats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get organization statistics by country
 */

export function useGetOrganizationStats<TData = Awaited<ReturnType<typeof getOrganizationStats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationStats>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationStatsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get class statistics grouped by two dimensions
 */
export const getClassStats = (
    params: GetClassStatsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<StatEntryResponseDto[]>(
      {url: `/admin/statistics/classes`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetClassStatsQueryKey = (params?: GetClassStatsParams,) => {
    return [
    `/admin/statistics/classes`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetClassStatsQueryOptions = <TData = Awaited<ReturnType<typeof getClassStats>>, TError = ErrorType<unknown>>(params: GetClassStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClassStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClassStatsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClassStats>>> = ({ signal }) => getClassStats(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClassStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClassStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getClassStats>>>
export type GetClassStatsQueryError = ErrorType<unknown>


export function useGetClassStats<TData = Awaited<ReturnType<typeof getClassStats>>, TError = ErrorType<unknown>>(
 params: GetClassStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClassStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassStats>>,
          TError,
          Awaited<ReturnType<typeof getClassStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClassStats<TData = Awaited<ReturnType<typeof getClassStats>>, TError = ErrorType<unknown>>(
 params: GetClassStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClassStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassStats>>,
          TError,
          Awaited<ReturnType<typeof getClassStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClassStats<TData = Awaited<ReturnType<typeof getClassStats>>, TError = ErrorType<unknown>>(
 params: GetClassStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClassStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get class statistics grouped by two dimensions
 */

export function useGetClassStats<TData = Awaited<ReturnType<typeof getClassStats>>, TError = ErrorType<unknown>>(
 params: GetClassStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClassStats>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetClassStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get ticket statistics with counts and revenue
 */
export const getTicketStats = (
    params: GetTicketStatsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TicketStatsResponseDto[]>(
      {url: `/admin/statistics/tickets`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetTicketStatsQueryKey = (params?: GetTicketStatsParams,) => {
    return [
    `/admin/statistics/tickets`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetTicketStatsQueryOptions = <TData = Awaited<ReturnType<typeof getTicketStats>>, TError = ErrorType<unknown>>(params: GetTicketStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTicketStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTicketStatsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTicketStats>>> = ({ signal }) => getTicketStats(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTicketStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTicketStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getTicketStats>>>
export type GetTicketStatsQueryError = ErrorType<unknown>


export function useGetTicketStats<TData = Awaited<ReturnType<typeof getTicketStats>>, TError = ErrorType<unknown>>(
 params: GetTicketStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTicketStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTicketStats>>,
          TError,
          Awaited<ReturnType<typeof getTicketStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTicketStats<TData = Awaited<ReturnType<typeof getTicketStats>>, TError = ErrorType<unknown>>(
 params: GetTicketStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTicketStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTicketStats>>,
          TError,
          Awaited<ReturnType<typeof getTicketStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTicketStats<TData = Awaited<ReturnType<typeof getTicketStats>>, TError = ErrorType<unknown>>(
 params: GetTicketStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTicketStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get ticket statistics with counts and revenue
 */

export function useGetTicketStats<TData = Awaited<ReturnType<typeof getTicketStats>>, TError = ErrorType<unknown>>(
 params: GetTicketStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTicketStats>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTicketStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Generates an onboarding link for Stripe Connect Express. Also acts as a status check: if the account is already connected, it updates the local database and returns status. Can be polled to confirm connection success.
 * @summary Generate Stripe Connect Onboarding Link
 */
export const connect = (
    connectStripeDto: ConnectStripeDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ConnectResponseDto>(
      {url: `/admin/stripe/connect`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: connectStripeDto, signal
    },
      );
    }
  


export const getConnectMutationOptions = <TError = ErrorType<void | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connect>>, TError,{data: ConnectStripeDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof connect>>, TError,{data: ConnectStripeDto}, TContext> => {

const mutationKey = ['connect'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connect>>, {data: ConnectStripeDto}> = (props) => {
          const {data} = props ?? {};

          return  connect(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConnectMutationResult = NonNullable<Awaited<ReturnType<typeof connect>>>
    export type ConnectMutationBody = ConnectStripeDto
    export type ConnectMutationError = ErrorType<void | void>

    /**
 * @summary Generate Stripe Connect Onboarding Link
 */
export const useConnect = <TError = ErrorType<void | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connect>>, TError,{data: ConnectStripeDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof connect>>,
        TError,
        {data: ConnectStripeDto},
        TContext
      > => {

      const mutationOptions = getConnectMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
